import React from 'react'
import { Statsig } from 'src/sdk/statsig'
import {
  SIMPLIFICAR_DESCONTOS_PDP_EXPERIMENT_ID,
  PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID,
} from 'src/components/common/StatsigExposure/StatsigExposure'

import { ProductPricing } from './ProductPricing/ProductPricing'
import { ProductPricingV2 } from './ProductPricingV2/ProductPricingV2'

export { ProductPricing }

export const ProductPricingExperiment = () => {
  const isRevampEnabled = Statsig.useStatsigFeatureGateValue(
    PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID
  )

  const isSimplificarDescontosEnabled = Statsig.useStatsigFeatureGateValue(
    SIMPLIFICAR_DESCONTOS_PDP_EXPERIMENT_ID
  )

  const isProductPricingV2Enabled =
    isRevampEnabled || isSimplificarDescontosEnabled

  return isProductPricingV2Enabled
    ? React.createElement(ProductPricingV2)
    : React.createElement(ProductPricing)
}
